import { jsx, jsxs } from "react/jsx-runtime";
import CrehanaIso from "@crehana/icons/logos/CrehanaIso";
import ArrowIosLeft from "@crehana/icons/outline/ArrowIosLeft";
import CloseSmall from "@crehana/icons/outline/CloseSmall";
import { Clamp, TextTag } from "@crehana/ui";
import classnames from "classnames";
import { useMainMenuContext, useMainMenuTranslation } from "../hooks/index.js";
const DrawerHeader = ({ className, title, onDismiss, onGoBack, isNew })=>{
    const { theme } = useMainMenuContext();
    const { t } = useMainMenuTranslation();
    return /*#__PURE__*/ jsxs("header", {
        className: classnames('w-full h-56 px-16 flex items-center justify-between flex-shrink-0', onGoBack ? 'font-subtitle3' : 'font-body3', theme.submenu.logoColorClassName, className),
        children: [
            onGoBack ? /*#__PURE__*/ jsxs("button", {
                type: "button",
                onClick: onGoBack,
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ jsx(ArrowIosLeft, {
                        size: 24,
                        ignoreColor: true,
                        className: classnames('fill-current mr-16', theme.submenu.accentIconColorClassName)
                    }),
                    /*#__PURE__*/ jsx(Clamp, {
                        clamp: 1,
                        children: title
                    }),
                    isNew && /*#__PURE__*/ jsx(TextTag, {
                        label: t('ACADEMY_TAG'),
                        type: "green",
                        className: "bg-secondary-main ml-8"
                    })
                ]
            }) : /*#__PURE__*/ jsxs("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ jsx(CrehanaIso, {
                        size: 24,
                        ignoreColor: true,
                        className: "mr-16 fill-current"
                    }),
                    title
                ]
            }),
            /*#__PURE__*/ jsx("button", {
                type: "button",
                onClick: onDismiss,
                className: classnames('w-32 h-32 flex items-center justify-end flex-shrink-0', theme.submenu.textColorClassName),
                children: /*#__PURE__*/ jsx(CloseSmall, {
                    size: 24,
                    ignoreColor: true,
                    className: "fill-current"
                })
            })
        ]
    });
};
const ui_DrawerHeader = DrawerHeader;
export default ui_DrawerHeader;
